import LocationCard from "@/components/LocationCard";
import { locations } from "@/data/locations";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

const LocationsSection = () => {
  return (
    <section id="locations" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeading
          eyebrow="Open now"
          title="Find a pod near you"
        />

        <div className="flex flex-wrap justify-center gap-6">
          {locations.map((location, i) => (
            <Reveal key={location.link} delay={i * 70} className="w-full sm:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)]">
              <LocationCard location={location} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
